<script setup lang="ts">
import type { CompareCell } from '~~/shared/compare/types'

// One comparison table cell: a check or cross icon, a short detail, or both.
const props = defineProps<{
  cell?: CompareCell
}>()

const yes = computed(() => {
  if (typeof props.cell === 'boolean') return props.cell
  if (props.cell && typeof props.cell === 'object') return props.cell.yes
  return null
})

const text = computed(() => {
  if (typeof props.cell === 'string') return props.cell
  if (props.cell && typeof props.cell === 'object') return props.cell.text
  return null
})
</script>

<template>
  <span
    v-if="cell === undefined"
    class="text-dimmed"
  >Not listed</span>
  <span
    v-else
    class="inline-flex items-start gap-2"
  >
    <UIcon
      v-if="yes !== null"
      :name="yes ? 'i-lucide-check' : 'i-lucide-x'"
      class="mt-0.5 size-4 shrink-0"
      :class="yes ? 'text-success' : 'text-dimmed'"
    />
    <span
      v-if="text"
      :class="yes === false ? 'text-muted' : 'text-toned'"
    >{{ text }}</span>
    <span
      v-else
      class="sr-only"
    >{{ yes ? 'Yes' : 'No' }}</span>
  </span>
</template>
